import CommonResponse from '../../common/model/CommonResponse';
import Project from '../model/Projects';
export default class APIListPartnersResponse extends CommonResponse {
    constructor(response) {
        var _a;
        super(response);
        this.projects = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.map(b => new Project(b));
    }
}
